<section>
  <div class="my-2">
    <form [formGroup]="formDevolutionDetail">
      <div class="row p-1">
        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
          <app-custom-inputgroup [inputValue]="codeNameArticle" [labelText]="'Artículo'"
            [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Artículo'" [required]="true"
            [recovery]="true" (onClick)="openArticleSelectionModal()"></app-custom-inputgroup>
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Artículos en Centro de Costo'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6 field-quantity">
          <app-custom-input-decimal [value]="rentalStockForm" [labelText]="'Existencia'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6 field-quantity">
          <app-custom-input-decimal formControlName="predevolutionQuantity"
            [labelText]="'Q.Predev.'"></app-custom-input-decimal>
          <!-- (onChangeNumber)="changePredevolutionQuantity($event)" -->
        </div>
        <div [hidden]="devolutionModel.isPredevolution" class="col-lg-1 col-md-2 col-sm-3 col-6 field-quantity">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Q.Almacén'"></app-custom-input-decimal>
          <!-- (onChangeNumber)="changeQuantity($event)" -->
        </div>
        <div [hidden]="devolutionModel.isPredevolution" class="col-lg-1 col-md-2 col-sm-3 col-6 field-quantity">
          <app-custom-input-decimal formControlName="cleaningQuantity" [labelText]="'Q.Limpieza'"
            (onChangeNumber)="changeCleaningQuantity($event)"></app-custom-input-decimal>
        </div>
        <div [hidden]="devolutionModel.isPredevolution" class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="cleaningValue"
            [labelText]="'Vr.Tot.Limpieza'"></app-custom-input-decimal>
        </div>
        <div [hidden]="devolutionModel.isPredevolution" class="col-lg-1 col-md-2 col-sm-3 col-6 field-quantity">
          <app-custom-input-decimal formControlName="repairQuantity" [labelText]="'Q.Reparación'"
            (onChangeNumber)="changeRepairQuantity($event)"></app-custom-input-decimal>
        </div>
        <div [hidden]="devolutionModel.isPredevolution" class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="repairValue"
            [labelText]="'Vr.Tot.Reparación'"></app-custom-input-decimal>
        </div>
        <div [hidden]="devolutionModel.isPredevolution" class="col mt-4 field-checkbox">
          <app-custom-checkbox formControlName="hasRepairs" [labelText]="'Rep.'"></app-custom-checkbox>
        </div>
        <div [hidden]="devolutionModel.isPredevolution" class="col-lg-1 col-md-2 col-sm-3 col-6 field-quantity">
          <app-custom-input-decimal formControlName="replacementQuantity" [labelText]="'Q.Falt.'"
            (onChangeNumber)="changeReplacementQuantity($event)"></app-custom-input-decimal>
        </div>
        <div [hidden]="devolutionModel.isPredevolution" class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="replacementUnitValue" [labelText]="'Vr.Unit.Falt.'"
            (onChangeNumber)="changeReplacementUnitValue($event)"></app-custom-input-decimal>
        </div>
        <div [hidden]="devolutionModel.isPredevolution" class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="replacementValue" [labelText]="'Tot.Falt.'"
            (onChangeNumber)="changeReplacementTotalValue($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-6 col-6 d-flex align-items-end justify-content-start mt-2 gap-1">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'success'"
            (onClick)="send()"></app-custom-button>
          <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'"
            (onClick)="clearForm()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>